import React from "react";
import { connect } from "react-redux";
import {
  FONT_STYLE_SIZE_CONFIGS,
  FONT_FAMILY_WEIGHT_MAPPING,
} from "../../../constants/document";

const FontWeightDropdown = props => {
  let className = "fontweight-dropdown-wrapper";
  if (
    props.coverpageThemeActionLabel &&
    props.coverpageThemeActionLabel === "ApplyTableFormula"
  ) {
    className += " align-left-side";
  }
  return (
    <div className={className} style={props.style}>
      <ul>
        {Object.entries(FONT_STYLE_SIZE_CONFIGS).map(([key, value]) => {
          const supportedFontWeight = FONT_FAMILY_WEIGHT_MAPPING[
            props.fontValue
          ].filter(style => style.name === key);
          const isActive =
            props.isParentActive &&
            FONT_STYLE_SIZE_CONFIGS[props.currentFontWeight] === value;

          if (supportedFontWeight.length > 0) {
            return (
              <li // eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role
                role="button"
                tabIndex={0}
                className={`fontweight-dropdown-listitem ${
                  isActive ? "active" : ""
                }`}
                onMouseDown={() => {
                  props.getFontStyleWeight(
                    props.fontStyle,
                    props.fontValue,
                    key,
                  );
                }}
                style={value}>
                {key}
              </li>
            );
          }

          return null;
        })}
      </ul>
    </div>
  );
};

const mapStateToProps = state => {
  const { coverpageThemeActionLabel } = state.DocumentStore;

  return { coverpageThemeActionLabel };
};

export default connect(mapStateToProps, null)(FontWeightDropdown);
